/**
 * Accounting Data - Stub Exports
 * Data now comes from GraphQL API via accountingStore.
 */

// Empty data arrays
export const invoices: never[] = [];
export const customers: never[] = [];
export const movements: never[] = [];
export const bankAccounts: never[] = [];
export const bankTransactions: never[] = [];
export const einvoices: never[] = [];
export const chartOfAccounts: never[] = [];
export const dueDates: never[] = [];
export const allDueDates: never[] = [];

// Invoice functions
export const getInvoiceById = () => undefined;
export const getInvoicesByCustomer = () => [];
export const getInvoicesByProject = () => [];
export const getInvoicesByStatus = () => [];
export const getInvoicesByDirection = () => [];
export const getIssuedInvoices = () => [];
export const getReceivedInvoices = () => [];
export const getOverdueInvoices = () => [];
export const getDraftInvoices = () => [];
export const getPendingInvoices = () => [];
export const getTotalOutstanding = () => 0;
export const getTotalOverdue = () => 0;
export const getInvoicesDueSoon = () => [];
export const searchInvoices = () => [];

// Customer functions
export const getCustomerById = () => undefined;
export const getActiveCustomers = () => [];
export const getCustomersByType = () => [];
export const getCustomersByTag = () => [];
export const getCustomerDisplayName = () => '';
export const getCustomerTaxId = () => undefined;
export const searchCustomers = () => [];
export const getVIPCustomers = () => [];

// Movement functions
export const getMovementById = () => undefined;
export const getMovementsByAccount = () => [];
export const getMovementsByInvoice = () => [];
export const getMovementsByTransaction = () => [];
export const getMovementsByDirection = () => [];
export const getCreditMovements = () => [];
export const getDebitMovements = () => [];
export const getMovementsByDateRange = () => [];
export const getTotalCredits = () => 0;
export const getTotalDebits = () => 0;
export const getAccountBalance = () => 0;
export const searchMovements = () => [];

// Bank functions
export const getBankAccountById = () => undefined;
export const getActiveBankAccounts = () => [];
export const getBankAccountsByType = () => [];
export const getTotalBankBalance = () => 0;
export const getTransactionsByAccount = () => [];
export const getTransactionsByStatus = () => [];
export const getPendingTransactions = () => [];
export const getUnreconciledTransactions = () => [];
export const getTransactionsByDateRange = () => [];
export const getIncomingTransactions = () => [];
export const getOutgoingTransactions = () => [];
export const getTransactionsByCategory = () => [];
export const searchBankTransactions = () => [];

// EInvoice functions
export const getEInvoiceById = () => undefined;
export const getEInvoiceByInvoiceId = () => undefined;
export const getEInvoicesByStatus = () => [];
export const getPendingEInvoices = () => [];
export const getAcceptedEInvoices = () => [];
export const getRejectedEInvoices = () => [];
export const getEInvoicesWithErrors = () => [];
export const getEInvoiceStatusLabel = () => '';
export const getEInvoiceStatusColor = () => '';

// Chart of Accounts functions
export const getAccountById = () => undefined;
export const getAccountsByCategory = () => [];
export const getRootAccounts = () => [];
export const getChildAccounts = () => [];
export const getLeafAccounts = () => [];
export const getActiveAccounts = () => [];
export const searchAccounts = () => [];
export const getAccountPath = () => [];

// Due Date functions
export const getDueDateById = () => undefined;
export const getDueDatesByInvoice = () => [];
export const getDueDatesByCustomer = () => [];
export const getDueDatesByStatus = () => [];
export const getOverdueDueDates = () => [];
export const getDueTodayDueDates = () => [];
export const getUpcomingDueDates = () => [];
export const getPaidDueDates = () => [];
export const getTotalOverdueAmount = () => 0;
export const getTotalDueTodayAmount = () => 0;
export const getTotalUpcomingAmount = () => 0;
export const getDueDatesByDateRange = () => [];
export const searchDueDates = () => [];
export const getDueDateSummary = () => ({ overdue: 0, dueToday: 0, upcoming: 0 });
